import { Components, Theme } from '@mui/material';

declare module '@mui/material/Table' {
  interface TablePropsVariantOverrides {
    bordered: true;
  }
}

export const MuiTable: Components<Omit<Theme, 'components'>>['MuiTable'] = {
  styleOverrides: {
    root: {
      boxShadow: 'none',
      backgroundColor: 'transparent',
    },
  },
};
